import "../../scss/client/client.scss";

/* ------------------------------- COMPONENTS ------------------------------- */
import "./components/alerts";
import "./components/cookies";
import "./components/gallery";
import "./components/modal";
import "./components/photoswipe";
import "./components/share";
import "./components/svg-lazy";
import "./components/tooltip";
import "./components/wp-block-table";
import "./components/multi-upload";

/* --------------------------------- SCRIPTS -------------------------------- */
import "./scripts/company";
import "./scripts/navigation";
import "./scripts/page";
import "./scripts/homepage";
import "./scripts/post-list";
import "./scripts/search";
import "./scripts/comment";
import "./scripts/comment-actions";
import "./scripts/avatar";
import "./scripts/post-card";
import "./scripts/quill-editor";
import "./scripts/like-button";
import "./scripts/post-like-button";
import "./scripts/post-actions";
import "./scripts/tabs";
import "./scripts/milestones";
import "./scripts/calculator";

/* ---------------------------------- UTILS --------------------------------- */
import "./utils/events";
import "./utils/inject-css";
import "./utils/smoothscroll";

/* ------------------------------------------------------ */
/*                     Modules - React                    */
/* ------------------------------------------------------ */
import React from "react";
import ReactDOM from "react-dom";
import { ClientApp } from "./client-app";
import { RENDER_DONE_EVENT } from "../core/utils/variables";

const appWrapper = document.createElement("div");
document.body.appendChild(appWrapper);

ReactDOM.render(<ClientApp />, appWrapper, () =>
  window.dispatchEvent(new Event(RENDER_DONE_EVENT, { bubbles: true }))
);
